import { createSlice } from '@reduxjs/toolkit';

interface ModalDialogState {
  isModalOpen: boolean;
}

export const initialState: ModalDialogState = {
  isModalOpen: false,
};

export const modalDialog = createSlice({
  name: 'app/modalDialog',
  initialState,
  reducers: {
    openModalDialog(state) {
      state.isModalOpen = true;
    },
    closeModalDialog(state) {
      state.isModalOpen = false;
    },
  },
});

export const actions = modalDialog.actions;

export const { openModalDialog, closeModalDialog } = modalDialog.actions;

export default modalDialog.reducer;

export const modalDialogState = (state: any) => state?.modalDialog;
